import { useAuth } from "contexts/AuthContext";

const asList = (value) => {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
};

export const hasAnyRole = (userRoles = [], requiredRoles = []) => {
  const roles = asList(userRoles);
  const required = asList(requiredRoles);
  if (!required.length) return true;
  return required.some((role) => roles.includes(role));
};

export const hasAllRoles = (userRoles = [], requiredRoles = []) => {
  const roles = asList(userRoles);
  const required = asList(requiredRoles);
  if (!required.length) return true;
  return required.every((role) => roles.includes(role));
};

export default function Guard({
  children,
  privilege,
  privileges,
  role,
  roles,
  requireAllRoles = false,
  fallback = null,
}) {
  const auth = useAuth();
  const requiredPrivileges = privileges || (privilege ? [privilege] : []);
  const userPrivileges = auth?.privileges || [];
  const requiredRoles = roles || (role ? [role] : []);
  const userRoles = auth?.userRoles || auth?.roles || auth?.careRoles || [];

  const privilegeAllowed =
    !requiredPrivileges.length ||
    (userPrivileges.length && requiredPrivileges.some((item) => userPrivileges.includes(item)));
  const roleAllowed =
    !requiredRoles.length ||
    (requireAllRoles ? hasAllRoles(userRoles, requiredRoles) : hasAnyRole(userRoles, requiredRoles));

  return privilegeAllowed && roleAllowed ? children : fallback;
}
